module.exports = __webpack_public_path__ + "img/76200.e1aeac53.jpg";